import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Lyrics from "@/pages/lyrics/page";
import LinerNotes from "@/pages/liner-notes/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/lyrics",
    element: <Lyrics />,
  },
  {
    path: "/liner-notes",
    element: <LinerNotes />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;